import { type ReactNode } from "react";

import { cn } from "@/lib/utils";
import type { LayoutSettings } from "@/types/global";

const CONTAINER_CLASS: Record<LayoutSettings["container"], string> = {
  default: "container",
  sm: "container max-w-3xl",
  md: "container max-w-4xl",
  lg: "container max-w-5xl",
  xl: "container max-w-6xl",
};

const PADDING_CLASS: Record<LayoutSettings["vertical_padding"], string> = {
  md: "py-12 md:py-16",
  lg: "py-20 md:py-24",
  xl: "py-24 md:py-32",
};

const BACKGROUND_CLASS: Record<LayoutSettings["background"], string> = {
  default: "bg-background",
  dark: "bg-[#080808]",
};

interface SectionProps {
  settings: LayoutSettings;
  className?: string;
  contained?: boolean;
  children: ReactNode;
}

export function Section({ settings, className, contained = true, children }: SectionProps) {
  return (
    <section
      className={cn(
        "relative overflow-hidden",
        PADDING_CLASS[settings.vertical_padding],
        BACKGROUND_CLASS[settings.background],
        className,
      )}
    >
      {contained ? <div className={CONTAINER_CLASS[settings.container]}>{children}</div> : children}
    </section>
  );
}

export { CONTAINER_CLASS };
